import { createFetcher } from '@/utils/fetcher';

export const apiSelfCareFetcher = createFetcher(process.env.NEXT_PUBLIC_API_URL as string);

export const localFetcher = createFetcher('/api', {
	parseResponsesAsJson: true,
});

export const apiCouponsFetcher = createFetcher(process.env.NEXT_PUBLIC_COUPONS_API_URL as string, {
	sendContentType: false,
});

export const apiGcssFetcher = createFetcher(process.env.NEXT_PUBLIC_GCSS_API_URL as string, {
	sendContentType: false,
});
